<template>
  <v-dialog v-model="dialog" max-width="680" @click:outside="cancel" :persistent="isLoading">
    <v-card>
      <v-card-title>
        <h3><strong>{{ $t('nyuukaPlanDeleteDialog.label.title') }}</strong></h3>
      </v-card-title>
      <v-card-text>
        {{ $t('nyuukaPlanDeleteDialog.message.confirmDelete', [denpyoNumber]) }}
        <v-text-field density="compact" variant="outlined" hide-details="auto" v-model="staffCode"
          class="mt-4" :label="$t('nyuukaPlanDeleteDialog.label.staffCode')" :counter="staffCodeLength"
          :maxLength="staffCodeLength" :disabled="isLoading" :rules="[rules.checkStaffCode]" />
        <div v-if="errorMessage" class="mt-4" style="color: red">
          {{ errorMessage }}
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel" :disabled="isLoading">{{ $t('common.action.cancel') }}</v-btn>
        <v-btn color="error" text @click="deletePlan" :loading="isLoading" :disabled="invalidInput">
          {{ $t('common.action.delete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/apis/staff";
import constant from "@/utils/constant";

export default {
  props: {
    dialogData: {
      type: Object,
      required: true,
    },
    handleOk: {
      type: Function,
      required: true,
    },
    handleCancel: {
      type: Function,
      required: true,
    }
  },
  computed: {
    denpyoNumber() {
      return this.dialogData.plan.denpyoNumber;
    },
    // 担当者コードは任意入力。入力されている場合のみ、半角英数字かつ桁数を確認する
    invalidInput() {
      if (!this.isValidStaffCode(this.staffCode)) return true;
      if (this.staffCode.length > this.staffCodeLength) return true;
      return false;
    },
  },
  data() {
    return {
      dialog: true,
      isLoading: false,
      errorMessage: "",
      errorList: [],
      staffCode: "",
      staffCodeLength: constant.STAFF_CODE_MAX_LENGTH,
      rules: {
        checkStaffCode: v => {
          return this.isValidStaffCode(v) || this.$t('nyuukaPlanDeleteDialog.validation.halfAlnum');
        },
      },
    };
  },
  methods: {
    // 未入力は許容する（任意項目のため）
    isValidStaffCode(v) {
      return /^[0-9A-Za-z]*$/.test(v ?? "");
    },
    cancel() {
      if (this.isLoading) return;
      this.handleCancel();
    },
    deletePlan() {
      this.isLoading = true;
      this.errorMessage = "";
      this.errorList = [];
      api.post("/nyuka/plan/delete", {
        denpyoNumber: this.denpyoNumber,
        staffId: this.staffCode,
      })
        .then((response) => {
          if (response.data?.status == 0) {
            this.errorMessage = "";
            this.errorList = [];
            this.handleOk();
          } else {
            this.errorMessage = response.data?.errorMessage || this.$t('nyuukaPlanDeleteDialog.message.deleteFailed');
            this.errorList = response.data?.errorList || [];
          }
        })
        .catch((error) => {
          console.error("Delete nyuuka plan error:", error);
          this.errorMessage = this.$t('common.message.systemError');
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
